import React from 'react';
import { PropTypes } from 'prop-types'
import './topbar.css'

const CircleIndicator = ({ indicatorValue }) => (
    <div className='indicator'>
        <span className='indicator-label'>{indicatorValue}</span>
    </div>
);

CircleIndicator.propTypes = {    
    indicatorValue: PropTypes.number.isRequired
}

export default CircleIndicator;